import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useRouter } from "vue-router/composables";

import { useAuthenticationStore } from "@/stores/authentication";

import AppThemeToggle from "./AppThemeToggle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavbarUserMenu',
  setup(__props) {

const authStore = useAuthenticationStore();
const router = useRouter();
const isMenuOpen = ref<boolean>(false);

const doLogout = async () => {
  await authStore.logout();
  isMenuOpen.value = false;
  router.push({ name: "Login" });
};

return { __sfc: true,authStore, router, isMenuOpen, doLogout, AppThemeToggle }
}

})